import { createFileRoute } from "@tanstack/react-router";
import { Hero } from "@/components/hero";
import { usePageTitle } from "@/hooks/use-page-title";

export const Route = createFileRoute("/")({
  component: HomePage,
});

function HomePage() {
  usePageTitle(undefined);
  return <Hero />;
}
